export const createNamespace = (namespaceSpec) => Object.assign(
//<X extends I>(f: [X]) =>
//  `${namespaceSpec.prefix}:${f}` as `${string & P}${string & X}`,
namespaceSpec.terms.reduce((acc, term) => {
    //acc[term] = `${namespaceSpec.prefix}${term}`
    acc[term] = `${namespaceSpec.iri}${term}`;
    return acc;
}, {}), {
    $prefix: namespaceSpec["prefix"],
    $iri: namespaceSpec["iri"],
});
